<app-dialog class="product-management-dialog">
  <ng-container dialog-title>
    {{ data.title }}
    <p>
      {{ 'module.productCatalogManagement.productManagementDialog.headerText' | translate }}
    </p>
  </ng-container>

  <ng-container dialog-content>
    <form [formGroup]="productManagementForm" class="form">
      <div class="form-info">
        <div class="form-line">
          <mat-form-field class="input">
            <input
              matInput
              [formControl]="manufacturerInput"
              [matAutocomplete]="auto"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.manufacturerText' | translate }}"
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let manufacturer of filteredManufacturers | async" [value]="manufacturer">
                {{ manufacturer }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="form-line">
          <mat-form-field class="input">
            <input
              formControlName="name"
              matInput
              autocomplete="off"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.nameText' | translate }}"
            />
          </mat-form-field>
        </div>

        <div class="form-line">
          <mat-form-field class="dropdown">
            <mat-select
              formControlName="type"
              disableOptionCentering
              panelClass="myPanelClass"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.luminaireCategoryText' | translate }}"
            >
              <mat-option *ngFor="let luminaire of luminaireCategories" [value]="luminaire.guid">
                {{ luminaire.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-line-multiple">
          <mat-form-field class="input-left">
            <input
              type="number"
              formControlName="watt"
              matInput
              autocomplete="off"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.performanceWattsText' | translate }}"
            />
          </mat-form-field>
          <mat-form-field class="input-right">
            <input
              formControlName="price"
              matInput
              autocomplete="off"
              mask="separator.2"
              min="0"
              thousandSeparator="."
              decimalMarker=","
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.netPriceText' | translate }}"
            />
          </mat-form-field>
        </div>

        <div class="form-line-multiple kelvin-lumen">
          <div class="label-kelvin">Kelvin* (Wählen sie mindestens eine Option)</div>
          <div class="label-lumens">Lumen*</div>
        </div>

        <div class="form-line kelvin-lumen">
          <mat-checkbox class="checkbox" formControlName="chkLumen4k">
            {{ 'module.productCatalogManagement.productManagementDialog.lightElectricity4kText' | translate }}
          </mat-checkbox>
          <mat-form-field class="input-lumen4k">
            <input type="number" formControlName="lumen4k" matInput autocomplete="off" />
          </mat-form-field>
        </div>

        <div class="form-line kelvin-lumen">
          <mat-checkbox class="checkbox" formControlName="chkLumen3k">
            {{ 'module.productCatalogManagement.productManagementDialog.lightElectricity3kText' | translate }}
          </mat-checkbox>
          <mat-form-field class="input-lumen3k">
            <input type="number" formControlName="lumen3k" matInput autocomplete="off" />
          </mat-form-field>
        </div>

        <div class="form-line-multiple">
          <mat-form-field class="optics">
            <input
              formControlName="optics"
              matInput
              autocomplete="off"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.opticsText' | translate }}"
            />
          </mat-form-field>
          <mat-form-field class="braid">
            <input formControlName="braid" matInput autocomplete="off" placeholder="Zopf*" />
          </mat-form-field>
          <mat-form-field class="tilt-angle">
            <input
              formControlName="tiltAngle"
              matInput
              autocomplete="off"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.tiltAngleText' | translate }}"
            />
          </mat-form-field>
        </div>

        <div class="form-line-multiple">
          <mat-form-field class="input">
            <input
              type="number"
              formControlName="warranty"
              matInput
              autocomplete="off"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.guaranteeYearsText' | translate }}"
            />
          </mat-form-field>

          <mat-form-field class="dropdown-controlwire">
            <mat-select
              formControlName="controlCore"
              disableOptionCentering
              panelClass="myPanelClass"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.controlWireText' | translate }}"
            >
              <mat-option *ngFor="let option of germanBoolean" [value]="option.value">
                {{ option.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="dropdown">
            <mat-select
              formControlName="dimming"
              disableOptionCentering
              panelClass="myPanelClass"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.dimmingText' | translate }}"
            >
              <mat-option *ngFor="let option of germanBoolean" [value]="option.value">
                {{ option.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-line-multiple">
          <mat-form-field class="input-left">
            <input
              formControlName="modelNumber"
              matInput
              autocomplete="off"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.modelNumberText' | translate }}"
            />
          </mat-form-field>
          <mat-form-field class="input-right">
            <input
              formControlName="sdMaterial"
              matInput
              autocomplete="off"
              placeholder="{{ 'module.productCatalogManagement.productManagementDialog.SDMaterialText' | translate }}"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="image-info">
        <div class="document-container" (click)="fileInput.click()" appDragndrop (fileDropped)="attachImage(lamp, $event)">
          <div class="upload-document-drop">
            <input type="file" #fileInput accept="image/*" (change)="attachImage(lamp, $event.target.files)" (click)="fileInput.value = null" hidden />
            <span class="fa fa-file file"></span>
            <div class="file-label">
              <label
                [ngClass]="{
                  'label1-valid': isImageValid,
                  'label1-invalid': !isImageValid
                }"
              >
                {{ 'module.productCatalogManagement.productManagementDialog.uploadImageText' | translate }}
              </label>
              <label
                [ngClass]="{
                  'label2-valid': isImageValid,
                  'label2-invalid': !isImageValid
                }"
              >
                {{ 'module.productCatalogManagement.productManagementDialog.validateImageText' | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="image-container" *ngIf="(data.isEditMode && isImageValid) || isNewImageUploaded">
          <div class="header">
            <div class="filename" [matTooltip]="imageName">
              {{ imageName }}
            </div>
            <span class="fa fa-times" aria-hidden="true" (click)="removeImage(lamp)"></span>
          </div>
          <div class="body">
            <img
              alt="lamp-img"
              *ngIf="isImageValid && lamp.image | async as pic; else loading"
              class="image"
              [attr.src]="pic"
              (error)="setDefaultImage()"
            />
            <div *ngIf="!isImageValid" class="default-image">
              <span class="fa fa-picture-o fa-2x"></span>
              <label class="default-image-label">{{ 'module.productCatalogManagement.lampProduct.noPictureText' | translate }}</label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container dialog-actions>
    <button class="btn btn-outline-primary" (click)="confirm()" [disabled]="isButtonDisabled()">
      {{ data.confirmText }}
    </button>
    <button class="btn btn-outline-primary" (click)="cancel()">
      {{ data.declineText }}
    </button>
  </ng-container>

  <ng-template #loading>
    <div class="spinner">
      <mat-spinner [strokeWidth]="5"></mat-spinner>
    </div>
  </ng-template>
</app-dialog>
